/* ---------- Rare, distant lightning behind the anchor ---------- */
(function () {
  // Phones: skip the full-screen canvas animation (it blocks the page for seconds on mobile CPUs).
  if (window.matchMedia('(max-width: 960px)').matches) {
    var c0 = document.querySelector('.bg-bolt'); if (c0) c0.style.display = 'none';
    var f0 = document.querySelector('.bg-flash'); if (f0) f0.style.display = 'none';
    return;
  }
  var gentle = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var flash = document.querySelector('.bg-flash');
  var canvas = document.querySelector('.bg-bolt');
  var ctx = canvas.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);

  var BUILD = 1600;     // ms the bolt spreads out while the glow slowly rises
  var STRIKE = 1000;    // ms of the strike, flicker and fade
  var INTENSITY = 0.5;  // softer, far-off storm
  var MAX_DEPTH = 5;
  var MAX_SEGMENTS = 4000;

  function rand(min, max) { return min + Math.random() * (max - min); }
  function resize() { canvas.width = Math.round(window.innerWidth * dpr); canvas.height = Math.round(window.innerHeight * dpr); }
  resize();
  window.addEventListener('resize', resize);

  function growChannel(segs, x, y, heading, length, depth, width, startTime, speed) {
    var travelled = 0;
    var stepBase = (depth === 0 ? 15 : 10 - depth) * dpr;
    var forkChance = [0.22, 0.16, 0.12, 0.08, 0.05, 0][depth];
    while (travelled < length && segs.length < MAX_SEGMENTS) {
      var step = stepBase * rand(0.5, 1.6);
      var angle = heading + rand(-0.75, 0.75);
      var nx = x + Math.cos(angle) * step, ny = y + Math.sin(angle) * step;
      segs.push({ x1: x, y1: y, x2: nx, y2: ny, depth: depth, width: width * (1 - (travelled / length) * 0.45),
        t0: startTime + travelled / speed, t1: startTime + (travelled + step) / speed });
      travelled += step; x = nx; y = ny;
      if (depth < MAX_DEPTH && Math.random() < forkChance) {
        var side = Math.random() < 0.5 ? -1 : 1;
        growChannel(segs, x, y, heading + side * rand(0.4, 1.2),
          (length - travelled) * rand(0.35, 0.8) + rand(30, 80) * dpr, depth + 1,
          width * rand(0.5, 0.68), startTime + travelled / speed, speed * rand(0.8, 1.1));
      }
    }
  }

  // Strikes stay high in the sky, off to the side of the anchor.
  function makeBolt(side, build) {
    var w = canvas.width, h = canvas.height;
    var xPct = side === 'left' ? rand(8, 26) : rand(74, 92);
    var length = h * rand(0.3, 0.42);
    var heading = Math.PI / 2 + (side === 'left' ? rand(-0.25, 0.1) : rand(-0.1, 0.25));
    var segs = [];
    for (var tries = 0; tries < 10 && segs.length < 450; tries++) {
      segs = [];
      growChannel(segs, w * xPct / 100, -10 * dpr, heading, length, 0, 4 * dpr, 0, length / build);
    }
    return { segs: segs, xPct: xPct };
  }

  function strikeIntensity(t) {
    if (gentle) return Math.max(0, 0.75 * (1 - t / STRIKE));
    if (t < 70) return 1;
    if (t < 150) return 0.3;
    if (t < 230) return 0.9;
    return Math.max(0, 0.9 * (1 - (t - 230) / (STRIKE - 230)));
  }

  var LAYERS = [
    { widthScale: 6, alpha: 0.06, color: '120, 160, 255' },
    { widthScale: 2.4, alpha: 0.22, color: '170, 200, 255' },
    { widthScale: 1, alpha: 1, color: '245, 249, 255' }
  ];

  function draw(segs, growTime, leaderAlpha, boltAlpha) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.globalCompositeOperation = 'lighter';
    ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    LAYERS.forEach(function (layer) {
      segs.forEach(function (s) {
        if (s.t0 > growTime) return;
        var k = s.t1 <= growTime ? 1 : (growTime - s.t0) / (s.t1 - s.t0);
        var depthFade = s.depth === 0 ? 1 : Math.pow(0.86, s.depth);
        var a = layer.alpha * depthFade * (boltAlpha > 0 ? boltAlpha : leaderAlpha) * INTENSITY;
        if (a < 0.003) return;
        ctx.strokeStyle = 'rgba(' + layer.color + ',' + a.toFixed(3) + ')';
        ctx.lineWidth = Math.max(0.5 * dpr, s.width * layer.widthScale);
        ctx.beginPath(); ctx.moveTo(s.x1, s.y1);
        ctx.lineTo(s.x1 + (s.x2 - s.x1) * k, s.y1 + (s.y2 - s.y1) * k);
        ctx.stroke();
      });
    });
  }

  function runBolt(side, build, done) {
    var bolt = makeBolt(side, build);
    flash.style.setProperty('--flash-x', bolt.xPct + '%');
    var start = performance.now();
    function frame(now) {
      var t = now - start;
      if (t < build) {
        var p = t / build;
        draw(bolt.segs, t, 0.15 + 0.35 * p * p, 0);
        flash.style.opacity = ((0.04 + 0.2 * p * p) * INTENSITY).toFixed(3);
      } else if (t < build + STRIKE) {
        var i = strikeIntensity(t - build);
        draw(bolt.segs, Infinity, 0, i * 0.8);
        flash.style.opacity = ((0.24 * (1 - (t - build) / STRIKE) + 0.4 * i) * INTENSITY).toFixed(3);
      } else {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        flash.style.opacity = 0;
        done(); return;
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  // A distant storm: a strike on the right, then a quicker answer on the left, then a long calm.
  function storm() {
    if (document.hidden) { setTimeout(storm, rand(25000, 45000)); return; }
    runBolt('right', BUILD, function () {
      setTimeout(function () {
        runBolt('left', BUILD * 0.6, function () { setTimeout(storm, rand(25000, 45000)); });
      }, rand(500, 1300));
    });
  }
  setTimeout(storm, rand(6000, 10000));
})();